<template>
  <header 
    class="header-area" 
    :class="[customClass, 
      { 
        'header-rounded': rounded,
        'tp-layer': type === 'popup',
        'header-sm': isShort,
        'title-left':titleLeft
      }
    ]"
  >
    <div class="header__side--left" v-if="config.alarm || config.back || config.homeLeft">
      <slot name="left">
        <button v-if="config.back" type="button" aria-label="뒤로가기" @click="goBack">
          <img src="@/assets/images/icon_back_b.png" alt="" />
        </button>
        <button v-if="config.alarm" type="button" aria-label="알람" @click="$emit('alarm')">
          <img src="@/assets/images/icon_alam_b.png" alt="" />
        </button>
        <button v-if="config.homeLeft" type="button" aria-label="홈" @click="$emit('home')">
          <img src="@/assets/images/icon_home_b.png" alt="" />
        </button>
      </slot>
    </div>

    <div v-if="title || $slots.title" class="header__title">
      <slot name="title">
        <h2>{{ title }}</h2>
      </slot>
    </div>

    <div class="header__side--right" v-if="config.homeRight || config.menu || config.close">
      <slot name="right">
        <button v-if="config.close" type="button" aria-label="닫기" @click="$emit('close')">
          <img src="@/assets/images/icon_close_b.png" alt="" />
        </button>
        <button v-if="config.homeRight" type="button" aria-label="홈" @click="$emit('home')">
          <img src="@/assets/images/icon_home_b.png" alt="" />
        </button>
        <button v-if="config.menu" type="button" aria-label="메뉴" @click="$emit('menu')">
          <img src="@/assets/images/icon_menu_b.png" alt="" />
        </button>
      </slot>
    </div>
  </header>
</template>

<script setup>
import { computed } from 'vue'
import { useRouter } from 'vue-router';
const router = useRouter();

const props = defineProps({
  type: { type: String, default: 'main' }, // 이미지의 유형과 매칭
  title: { type: String, default: '' },
  rounded: { type: Boolean, default: false },
  customClass: { type: String, default: '' },
  isShort: { type: Boolean, default: false },
  titleLeft: { type: Boolean, default: false },
})

const emit = defineEmits(['close', 'back', 'home', 'menu', 'alarm'])

// Configuration Matrix
const config = computed(() => {
  const configs = {
    // 1. 메인 헤더
    main: { alarm: false, back: false, homeLeft: false, menu: false, close: false },
    
    // 2. 서브 헤더 (A, B, C, D)
    subA: { alarm: false, back: true, homeLeft: false, homeRight: false, menu: true, close: false },
    subB: { alarm: false, back: true, homeLeft: false, homeRight: false, menu: false, close: false },
    subB1: { alarm: false, back: false, homeLeft: false, homeRight: false, menu: false, close: false }, //뒤로가기 버튼 미사용헤더
    subC: { alarm: false, back: false, homeLeft: false, homeRight: false, menu: false, close: false }, // 빈 헤더
    subD: { alarm: false, back: true, homeLeft: false, homeRight: false, menu: true, close: false },
    subE: { alarm: false, back: true, homeLeft: false, homeRight: true, menu: true, close: false },
    
    // 3. 전체메뉴 헤더 (텍스트: 홈 버튼 / 표기: < 화살표)
    fullMenu: { alarm: false, back: true, homeLeft: false, homeRight: false, menu: false, close: true },
    
    // 4. 단일 버튼 헤더
    closeOnly: { alarm: false, back: false, homeLeft: false, homeRight: false, menu: false, close: true },
    
    // 5. 팝업용 헤더들
    popup: { alarm: false, back: false, homeLeft: false, homeRight: false, menu: false, close: true },
  }
  return configs[props.type] || configs.main
})

const goBack = () => {
  // 부모(레이아웃이나 페이지)에게 클릭되었다고 먼저 알림
  emit('back');
  
  // 만약 부모에서 별도의 처리를 하지 않는다면 기본 동작으로 뒤로가기 실행
  // (필요에 따라 이 로직을 부모가 가로채게 할 수도 있습니다)
  // router.back();
};

</script>